import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/timeActions';

const timeActions = {

    getTimeSpentOnProject(projectID) {
        return dispatch => {
            dispatch(actions.getTimeSpentOnProject());

            request
                .get(env.tashi + '/projects/' + projectID + '/timeSpent')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.getTimeSpentOnProject({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.getTimeSpentOnProject({ status: "success", data: res.text }));
                    } else {
                        dispatch(actions.getTimeSpentOnProject({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    getTimeSpentOnProjectByUser(projectID, userID) {
        return dispatch => {
            dispatch(actions.getTimeSpentOnProjectByUser());

            request
                .get(env.tashi + '/projects/' + projectID + '/timeSpent')
                .query({
                    user: userID
                })
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.getTimeSpentOnProjectByUser({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.getTimeSpentOnProjectByUser({ status: "success", data: res.text }));
                    } else {
                        dispatch(actions.getTimeSpentOnProjectByUser({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    getTimeSpentOnTask(taskID) {
        return dispatch => {
            dispatch(actions.getTimeSpentOnTask());

            request
                .get(env.tashi + '/tasks/' + taskID + '/timeSpent')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.getTimeSpentOnTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.getTimeSpentOnTask({ status: "success", data: res.text }));
                    } else {
                        dispatch(actions.getTimeSpentOnTask({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    getTimeSpentOnTaskByUser(taskID, userID) {
        return dispatch => {
            dispatch(actions.getTimeSpentOnTaskByUser());

            request
                .get(env.tashi + '/tasks/' + taskID + '/timeSpent')
                .query({
                    user: userID
                })
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.getTimeSpentOnTaskByUser({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.getTimeSpentOnTaskByUser({ status: "success", data: res.text }));
                    } else {
                        dispatch(actions.getTimeSpentOnTaskByUser({ status: "failure", data: res.status }));
                    }
                });
        };
    }

};

export default timeActions;


/** WEBPACK FOOTER **
 ** ./src/app/actions/timeActionCreators.js
 **/